import React, { useState } from "react";
import { aceitarTermos } from "../../api/usuarios";
import "./TermosModal.scss";

const EMAIL_CONTATO = "uniagenda.contato@gmail.com";

const TERMOS_INTRO = [
  "Os presentes Termos de Uso estabelecem as regras para o acesso e a utilização da plataforma disponibilizada para fins acadêmicos. Ao utilizar o sistema, o usuário declara estar de acordo com as condições previstas neste documento e com as demais normas aplicáveis.",
];

const SECOES_TERMOS = [
  {
    titulo: "Aceite e condições de uso",
    paragrafos: [
      'Para utilizar a AgendaUni, o usuário deverá confirmar sua concordância clicando no botão "Li e concordo com os Termos de Uso e Política de Privacidade".',
      "Menores de Idade: Caso o Usuário seja menor de idade, o aceite e a utilização do sistema deverão ocorrer sob a responsabilidade e supervisão de seus pais ou responsáveis legais, que serão responsáveis pelos atos praticados pelo menor dentro da plataforma.",
      "Aceitação Integral: A utilização da plataforma representa a concordância integral e incondicional com estes Termos e com a Política de Privacidade. Caso o usuário não esteja de acordo com qualquer uma das disposições, deverá interromper imediatamente a utilização da plataforma.",
    ],
  },
  {
    titulo: "Definições",
    paragrafos: [
      "AgendaUni: Empresa responsável pelo desenvolvimento e manutenção do sistema.",
      "Instituição Contratante: Unidade de ensino que mantém contrato vigente com a AgendaUni.",
      "Usuário: Estudantes, pais, responsáveis ou colaboradores vinculados a uma instituição contratante.",
      "Responsável: Pessoa legalmente encarregada pelo aluno menor de idade.",
    ],
  },
  {
    titulo: "Condições de acesso",
    paragrafos: [
      "O acesso à plataforma é limitado a usuários que possuam vínculo acadêmico ou contratual ativo com uma unidade de ensino parceira da AgendaUni.",
      "Finalidade: A plataforma deverá ser utilizada exclusivamente para fins acadêmicos e para atividades relacionadas à instituição.",
      "Uso Pessoal: As credenciais de acesso são pessoais, individuais e intransferíveis. É proibido ao usuário compartilhá-las com terceiros que não estejam autorizados, sem prejuízo da adoção de outras medidas administrativas, cíveis ou criminais que sejam cabíveis.",
    ],
  },
  {
    titulo: "Falhas, vulnerabilidades e segurança da plataforma",
    paragrafos: [
      "Não é permitido aos usuários explorar, testar, manipular ou tirar proveito de forma deliberada de falhas, vulnerabilidades ou comportamentos inesperados da AgendaUni com o objetivo de obter acesso não autorizado, alterar informações, obter vantagens ou provocar prejuízos.",
      "Caso seja identificada alguma falha ou vulnerabilidade, ela deverá ser comunicada à AgendaUni ou à instituição contratante por meio dos canais disponibilizados para essa finalidade.",
      "A exploração intencional de vulnerabilidades, as tentativas de invasão, o acesso sem autorização, a manipulação indevida de informações ou qualquer interferência no funcionamento da plataforma poderão ocasionar a suspensão ou exclusão da conta, sem prejuízo das medidas administrativas, civis ou criminais aplicáveis.",
    ],
  },
  {
    titulo: "Restrições e proibições",
    paragrafos: [
      "É vedado ao usuário e à instituição contratante:",
      "utilizar a AgendaUni para finalidades ilícitas, ofensivas, discriminatórias ou que possam causar prejuízos a terceiros;",
      "buscar acesso, utilização ou obtenção de informações de contas, dados ou áreas da plataforma sem a devida autorização;",
      "copiar, alterar, reproduzir ou realizar engenharia reversa do sistema, de seu código-fonte ou de quaisquer de seus componentes;",
      "inserir ou distribuir vírus, códigos maliciosos ou qualquer outro recurso capaz de comprometer o funcionamento ou a segurança da plataforma;",
      "utilizar a AgendaUni ou qualquer de seus componentes para criar, treinar ou alimentar aplicações, sistemas ou serviços concorrentes ou destinados a substituí-la, integral ou parcialmente, sem autorização prévia.",
      "O descumprimento dessas disposições poderá ocasionar a suspensão ou o cancelamento do acesso à plataforma, sem prejuízo das demais medidas cabíveis.",
    ],
  },
  {
    titulo: "Direitos de Conteúdo",
    paragrafos: [
      "Todo conteúdo disponibilizado na plataforma AgendaUni, incluindo, mas não se limitando a, textos, interfaces, layouts, designs, logotipos, ícones, elementos visuais, estrutura do sistema e software, encontra-se protegido pelas legislações aplicáveis de direitos autorais e propriedade intelectual.",
      "É proibido reproduzir, modificar, distribuir, realizar engenharia reversa ou utilizar, de qualquer outra maneira não autorizada, os conteúdos ou o sistema.",
    ],
  },
  {
    titulo: "Limitação de responsabilidade",
    paragrafos: [
      "Os conteúdos inseridos na plataforma pelas instituições contratantes ou por seus usuários, como eventos, turmas, comunicados e informações acadêmicas, são de responsabilidade das próprias instituições e de seus usuários, que declaram possuir os direitos ou as autorizações necessárias para sua utilização.",
      "A AgendaUni atua como fornecedora da plataforma tecnológica e, por esse motivo, não se responsabiliza pelos conteúdos inseridos pelas instituições ou por seus usuários, incluindo, mas não se limitando a, eventos, informações acadêmicas, comunicados ou quaisquer outros dados publicados na plataforma.",
      "Da mesma forma, a AgendaUni não se responsabiliza por danos indiretos, perdas de dados, interrupções do serviço provocadas por terceiros, falhas de conexão, problemas relacionados aos dispositivos dos usuários ou utilização inadequada da plataforma.",
    ],
  },
  {
    titulo: "Suspensão ou encerramento de acesso",
    paragrafos: [
      "A AgendaUni poderá suspender ou restringir o acesso à plataforma, de forma temporária ou permanente, quando identificar utilização indevida, descumprimento destes Termos de Uso, atividades ilegais ou qualquer conduta que possa comprometer a segurança da plataforma ou de seus usuários.",
    ],
  },
  {
    titulo: "Mudanças e Atualizações",
    paragrafos: [
      "A evolução faz parte da forma como operamos. Por isso, estes Termos de Uso poderão ser atualizados sempre que necessário, a fim de acompanhar alterações nos serviços oferecidos ou na legislação aplicável.",
      "Quando houver mudanças consideradas significativas, serão adotados esforços para comunicá-las ao usuário.",
      "A continuidade do acesso ou utilização do site após a realização dessas alterações será considerada como concordância com os novos termos.",
    ],
  },
];

const POLITICA_TITULO = "POLÍTICA DE PRIVACIDADE";

const POLITICA_INTRO = [
  "Esta Política de Privacidade descreve de que maneira a AgendaUni realiza a coleta e o tratamento de dados pessoais de estudantes, responsáveis e usuários. Este documento integra os Termos de Uso e busca apresentar, de maneira clara e transparente, como os dados pessoais são tratados.",
  "Ao utilizar a AgendaUni, você declara estar ciente e de acordo com o tratamento de seus dados conforme as disposições desta Política e a legislação aplicável à proteção de dados pessoais.",
];

const SECOES_POLITICA = [
  {
    titulo: "Quem somos?",
    paragrafos: [
      "A AgendaUni é uma plataforma desenvolvida com o propósito de facilitar a comunicação, a organização e o gerenciamento das atividades entre instituições de ensino e seus integrantes. A plataforma busca reunir, em um único ambiente, informações relevantes, como eventos, avisos, comunicados e outras atividades, contribuindo para uma rotina mais organizada de estudantes, professores, coordenadores e gestores.",
    ],
  },
  {
    titulo: "Conceitos importantes",
    paragrafos: [
      "Para tornar esta Política mais fácil de compreender, são utilizadas as definições previstas na Lei Geral de Proteção de Dados (LGPD):",
      "Titular de Dados: pessoa física a quem os dados pessoais estão relacionados, como estudantes, pais ou colaboradores.",
      "Dado Pessoal: qualquer informação capaz de identificar uma pessoa ou que possa permitir sua identificação, como nome, CPF ou e-mail.",
      "Tratamento: qualquer atividade realizada envolvendo dados pessoais, incluindo coleta, acesso, processamento, utilização e armazenamento.",
      "Finalidade: propósito para o qual determinada informação é utilizada.",
    ],
  },
  {
    titulo: "Quem pode utilizar a AgendaUni?",
    paragrafos: [
      "A AgendaUni destina-se exclusivamente às instituições de ensino e aos usuários que tenham sido autorizados, pela instituição, a utilizar a plataforma.",
    ],
  },
  {
    titulo: "Dados coletados e finalidades",
    paragrafos: [
      "A AgendaUni realiza o tratamento de determinadas categorias de dados pessoais necessárias ao funcionamento, à gestão e à segurança da plataforma.",
      "Identificação e Contato: Nome completo e e-mail.",
      "Finalidade: realização do cadastro de acesso, comunicação e organização das turmas.",
      "Dados Acadêmicos e pedagógicos: Senha institucional.",
      "Finalidade: realização do cadastro de acesso, comunicação e organização das turmas.",
      "Além das finalidades mencionadas, os dados pessoais também poderão ser tratados para:",
      "(i) cumprimento de obrigações legais e regulatórias;",
      "(ii) atendimento de solicitações realizadas por autoridades competentes;",
      "(iii) prevenção de fraudes e proteção da segurança dos usuários;",
      "(iv) aprimoramento e aperfeiçoamento da AgendaUni.",
      "A AgendaUni não disponibiliza cadastro por meio de contas Google, Apple ou outros provedores externos. Também não solicita informações pessoais além daquelas necessárias para o funcionamento da plataforma.",
    ],
  },
  {
    titulo: "Permissão de notificações",
    paragrafos: [
      "A plataforma solicita a permissão para notificações com a finalidade exclusiva de enviar avisos, comunicados e informações relacionadas às funcionalidades da AgendaUni.",
      "As notificações têm finalidade exclusivamente funcional e não são utilizadas para publicidade ou marketing.",
      "O usuário poderá optar por permitir ou não o recebimento de notificações. A recusa dessa permissão poderá afetar o funcionamento de determinadas funcionalidades da plataforma.",
      "A AgendaUni não realiza a coleta de dados de localização ou GPS.",
    ],
  },
  {
    titulo: "Controlador e Operador",
    paragrafos: [
      "A instituição contratante será responsável por garantir a legitimidade do fornecimento dos dados pessoais e atuará como controladora desses dados. O CONTRATADO (AgendaUni), por sua vez, realizará o tratamento necessário para o funcionamento da plataforma, na condição de operador.",
    ],
  },
  {
    titulo: "Cookies",
    paragrafos: [
      "A AgendaUni utiliza cookies estritamente necessários para o funcionamento da plataforma e para manter o usuário conectado.",
      "Categoria: Estritamente necessário",
      "Finalidade: manter o usuário conectado, possibilitando a renovação da sessão e o recurso de “continuar conectado”.",
    ],
  },
  {
    titulo: "Armazenamento de dados",
    paragrafos: [
      "Para possibilitar o funcionamento adequado da AgendaUni, determinados dados poderão ser armazenados temporariamente no navegador ou no dispositivo utilizado pelo usuário.",
      "Essas informações podem compreender dados necessários para manter o acesso à conta, informações básicas do perfil, preferências de navegação, recursos relacionados à segurança do acesso e informações temporárias necessárias ao funcionamento de determinadas funcionalidades, inclusive em situações de ausência de conexão com a internet.",
      "No aplicativo, as informações relacionadas ao acesso à conta são armazenadas de maneira segura, utilizando os mecanismos de proteção disponíveis no próprio dispositivo.",
      "Os dados armazenados localmente serão excluídos quando o usuário realizar logout, desinstalar o aplicativo ou limpar os dados armazenados pelo navegador, conforme aplicável.",
    ],
  },
  {
    titulo: "Compartilhamento de dados",
    paragrafos: [
      "Os dados pessoais tratados pela plataforma não serão vendidos, comercializados ou utilizados com finalidade de exploração comercial.",
      "O compartilhamento poderá ocorrer somente quando necessário para a prestação e o funcionamento dos serviços, para a gestão institucional e administrativa, ou com provedores de tecnologia e serviços essenciais, incluindo empresas responsáveis por hospedagem em nuvem, segurança da informação e infraestrutura tecnológica.",
      "Também poderá haver compartilhamento com órgãos públicos quando isso for necessário para o cumprimento de obrigações legais ou regulatórias.",
    ],
  },
  {
    titulo: "Segurança e armazenamento",
    paragrafos: [
      "Os dados pessoais tratados pela AgendaUni são mantidos em servidores seguros localizados no Brasil, com acesso controlado e limitado a pessoas e sistemas autorizados. Para proteger essas informações contra acessos indevidos, perda, alteração ou utilização inadequada, a plataforma adota medidas técnicas e organizacionais de segurança.",
      "As informações são transmitidas de maneira segura e contam com mecanismos de criptografia para sua proteção. As senhas dos usuários não são armazenadas de forma que possam ser visualizadas ou lidas pela plataforma, sendo aplicadas técnicas específicas para garantir sua proteção.",
      "O acesso às contas também conta com mecanismos de autenticação e segurança, como tokens de acesso com validade limitada, controle de tentativas de login e verificação das permissões diretamente no servidor.",
      "Dados armazenados: a AgendaUni poderá armazenar nome, e-mail, tipo de usuário, instituição e turmas às quais o usuário pertence, eventos e interações realizadas na plataforma, informações necessárias para o envio de notificações e registros relacionados à segurança e auditoria, como endereço IP.",
      "Período de Guarda: os dados permanecerão armazenados enquanto forem necessários para o funcionamento da plataforma e para a manutenção do vínculo do usuário com a instituição. Após esse período, poderão ser conservados pelo prazo necessário ao cumprimento de obrigações legais ou regulatórias ou ao exercício regular de direitos.",
      "Compartilhamento com terceiros: a AgendaUni utiliza o Google Firebase exclusivamente para o envio de notificações push. Para essa finalidade, poderão ser enviados os dados necessários à execução do serviço, como o identificador do dispositivo e o conteúdo da notificação. A plataforma não utiliza serviços de publicidade, rastreamento ou análise de terceiros para o tratamento dos dados dos usuários.",
      "Responsabilidade do usuário: cabe ao usuário manter suas credenciais de acesso em sigilo, evitando compartilhá-las com terceiros, além de adotar cuidados adequados para proteger sua conta e o dispositivo utilizado para acessar a plataforma.",
    ],
  },
  {
    titulo: "Exclusão de dados",
    paragrafos: [
      "A exclusão de dados ocorre de forma imediata e definitiva. Após a exclusão, o registro é removido diretamente do banco de dados. Quando um usuário é excluído pelo administrador, são removidos, na mesma operação:",
      "cadastro do usuário, incluindo nome, hash da senha, tipo e instituição;",
      "vínculos com turmas, sejam eles de aluno, responsável ou coordenador;",
      "eventos criados pelo usuário;",
      "tokens de sessão e de redefinição de senha;",
      "tokens de notificações push associados aos seus dispositivos.",
      "Informações que podem permanecer após a exclusão: mesmo após a exclusão, determinadas informações poderão permanecer temporariamente em situações específicas:",
      "Registros de auditoria: são mantidos para fins de segurança e prestação de contas, registrando informações como quem realizou a exclusão, o que foi excluído, quando ocorreu e o respectivo endereço IP. Informações sensíveis, como senhas e tokens, permanecem mascaradas nesses registros.",
      "Backups: os dados excluídos poderão permanecer nas cópias de segurança por até 7 dias, até que ocorra a substituição e descarte do backup mais antigo.",
    ],
  },
  {
    titulo: "Seus direitos",
    paragrafos: [
      "O titular dos dados, ou seu responsável legal, poderá solicitar, observados os limites e as condições previstos na legislação de proteção de dados pessoais, a qualquer momento:",
      "confirmação da existência e acesso aos dados tratados;",
      "correção de informações incompletas, incorretas ou desatualizadas;",
      "eliminação de dados tratados com base no consentimento, respeitados os prazos legais de guarda;",
      "informações sobre as entidades com as quais os dados foram compartilhados.",
      "As solicitações serão avaliadas de acordo com a LGPD e demais normas aplicáveis. Em determinadas situações, por razões legais, regulatórias, educacionais ou de segurança, a solicitação poderá não ser atendida integralmente. Nesses casos, o titular será informado sobre os motivos da impossibilidade, sempre que essa comunicação for exigida pela legislação.",
    ],
  },
  {
    titulo: "Alterações desta política",
    paragrafos: [
      "Esta Política de Privacidade poderá ser atualizada sempre que necessário, especialmente em razão de alterações na legislação, nas funcionalidades da plataforma ou nas formas de tratamento dos dados pessoais.",
      "Quando houver mudanças relevantes, uma nova versão da Política será disponibilizada em local apropriado.",
    ],
  },
];

const CONTATO_TITULO = "Dúvidas ou Comentários?";
const CONTATO_ANTES =
  "Se tiver dúvidas, não hesite em nos contatar através do e-mail ";
const CONTATO_DEPOIS = ".";
const LEGISLACAO =
  "Esta Política de Privacidade é regida pela legislação brasileira, especialmente pela Lei nº 13.709/2018 (Lei Geral de Proteção de Dados Pessoais – LGPD)";

export default function TermosModal({ usuario, onAceito }) {
  const [lido, setLido] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState(null);

  if (!usuario || usuario.termosAceitosEm) {
    return null;
  }

  const handleAceitar = async () => {
    setCarregando(true);
    setErro(null);
    try {
      await aceitarTermos();
      if (onAceito) {
        onAceito();
      }
    } catch (err) {
      setErro("Erro ao aceitar termos. Tente novamente.");
      console.error(err);
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="termos-modal-overlay">
      <div className="termos-modal__card">
        <div className="termos-modal__header">
          <h2 className="termos-modal__title">
            Termos de Uso e Política de Privacidade
          </h2>
          <p className="termos-modal__subtitle">
            Leia atentamente antes de continuar utilizando a plataforma.
          </p>
        </div>

        <div className="termos-modal__body">
          {TERMOS_INTRO.map((paragrafo, i) => (
            <p className="termos-modal__intro" key={i}>
              {paragrafo}
            </p>
          ))}

          {SECOES_TERMOS.map((secao) => (
            <section className="termos-modal__section" key={secao.titulo}>
              <h4 className="termos-modal__section-title">{secao.titulo}</h4>
              {secao.paragrafos.map((paragrafo, i) => (
                <p key={i}>{paragrafo}</p>
              ))}
            </section>
          ))}

          <hr className="termos-modal__divisor" />
          <h3 className="termos-modal__bloco-title">{POLITICA_TITULO}</h3>

          {POLITICA_INTRO.map((paragrafo, i) => (
            <p className="termos-modal__intro" key={i}>
              {paragrafo}
            </p>
          ))}

          {SECOES_POLITICA.map((secao) => (
            <section className="termos-modal__section" key={secao.titulo}>
              <h4 className="termos-modal__section-title">{secao.titulo}</h4>
              {secao.paragrafos.map((paragrafo, i) => (
                <p key={i}>{paragrafo}</p>
              ))}
            </section>
          ))}

          <div className="termos-modal__contact">
            <p className="termos-modal__contact-title">{CONTATO_TITULO}</p>
            <p>
              {CONTATO_ANTES}
              <a href={`mailto:${EMAIL_CONTATO}`}>{EMAIL_CONTATO}</a>
              {CONTATO_DEPOIS}
            </p>
            <p className="termos-modal__legislacao">{LEGISLACAO}</p>
          </div>
        </div>

        <div className="termos-modal__footer">
          <label className="termos-modal__checkbox">
            <input
              type="checkbox"
              checked={lido}
              onChange={(e) => setLido(e.target.checked)}
            />
            <span className="termos-modal__checkbox-label">
              Li e concordo com os <strong>Termos de Uso</strong> e a{" "}
              <strong>Política de Privacidade</strong>.
            </span>
          </label>

          {erro && <div className="termos-modal__error">{erro}</div>}

          <button
            type="button"
            className={`termos-modal__button ${!lido || carregando ? "is-disabled" : ""}`}
            disabled={!lido || carregando}
            onClick={handleAceitar}
          >
            {carregando ? "Processando..." : "Continuar"}
          </button>
        </div>
      </div>
    </div>
  );
}
